import React from 'react';
import { Outlet } from 'react-router-dom';

import AuthDialog from 'components/Dialogs/AuthDialog';
import ErrorBoundary from 'components/ErrorBoundary';

const LayoutAuth = () => (
  <>
    <ErrorBoundary>
      <AuthDialog />
    </ErrorBoundary>

    <Outlet />
  </>
);
export default LayoutAuth;
